/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { IngestionPipeline } from '../models/IngestionPipeline';

export class ListIngestionPipelinesResponse {
  /**
  * List of ingestion pipelines
  */
  'ingestionPipelines': Array<IngestionPipeline>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "ingestionPipelines",
      "baseName": "ingestionPipelines",
      "type": "Array<IngestionPipeline>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListIngestionPipelinesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

